import { useMemo } from 'react';
import { FlexLayout, RadioFieldGroup } from '@gv/triage-components';

import { CallOutcomeType } from 'types';
import { useCorporateOptions } from 'hooks/refer';
import {
  getCallOutcomeTitles,
  getBlockedCallOutcomeTypes,
  featureAvailableForHospital,
} from 'utils/helpers';
import {
  useFormEntities,
  callOutcomeModel,
  CheckProtocolsInfo,
  CaseFormTextOutProps,
} from 'components/cases/form';

import { CallOutcomeRefer } from '../refer';
import { CallOutcomeAction } from '../action';

export const CallOutcomeMain = (props: CaseFormTextOutProps) => {
  const { hospitalId } = useFormEntities();
  const { corporateGroupOptions, isCorporateGroupFetching } =
    useCorporateOptions(hospitalId);

  const blockedCallOutcomeTypes = useMemo(
    () => getBlockedCallOutcomeTypes(hospitalId),
    [hospitalId]
  );

  const hospitalCallOutcomeTitles = useMemo(
    () => getCallOutcomeTitles(hospitalId),
    [hospitalId]
  );

  const hasAccessToTransferBackline = featureAvailableForHospital(
    hospitalId,
    'CALL_OUTCOME_TRANSFER_TO_BACKLINE'
  );

  return (
    <FlexLayout gap={24} flexDirection="column">
      <div>
        <RadioFieldGroup
          label="Select call outcome"
          name={callOutcomeModel.type}
          items={[
            { label: 'Appointment', value: CallOutcomeType.Appointment },
            { label: 'Emergency', value: CallOutcomeType.Emergency },
            {
              label: 'Administrative',
              value: CallOutcomeType.Administrative,
              hasAccess: !blockedCallOutcomeTypes?.includes(
                CallOutcomeType.Administrative
              ),
            },
            {
              value: 'transferToBackline',
              hasAccess: hasAccessToTransferBackline,
              label:
                hospitalCallOutcomeTitles?.transferToBackline ??
                'Transfer to backline',
            },
          ]}
        />
      </div>

      <CheckProtocolsInfo hospitalType="other">
        <CallOutcomeAction
          corporateOptions={corporateGroupOptions}
          isCorporateFetching={isCorporateGroupFetching}
        />

        <CallOutcomeRefer
          {...props}
          corporateOptions={corporateGroupOptions}
          isCorporateFetching={isCorporateGroupFetching}
        />
      </CheckProtocolsInfo>
    </FlexLayout>
  );
};
